<template>
  <sub-nav>
    <b-nav-item key="news"
      href="#" @click="$emit('click')" link-classes="pb-0 pt-0">
      <router-link to="/news">お知らせ</router-link>
    </b-nav-item>
    <b-nav-item key="help" 
      href="#" @click="$emit('click')" link-classes="pb-0 pt-0">
      <router-link to="/help">はじめに</router-link>
    </b-nav-item>
    <b-nav-item key="game" 
      href="#" @click="$emit('click')" link-classes="pb-0 pt-0">
      <router-link to="/help/game">ゲームルール</router-link>
    </b-nav-item>
    <b-nav-item key="dicebattle" 
      href="#" @click="$emit('click')" link-classes="pb-0 pt-0">
      <router-link to="/help/dicebattle">ダイスバトル</router-link>
    </b-nav-item>
    <b-nav-item key="data" 
      href="#" @click="$emit('click')" link-classes="pb-0 pt-0">
      <router-link to="/help/data">データ</router-link>
    </b-nav-item>
    <b-nav-item key="etc" 
      href="#" @click="$emit('click')" link-classes="pb-0 pt-0">
      <router-link to="/help/etc">その他</router-link>
    </b-nav-item>
    <b-nav-item key="special" 
      href="#" @click="$emit('click')" link-classes="pb-0 pt-0">
      <router-link to="/special">提供</router-link>
    </b-nav-item>
  </sub-nav>
</template>

<script>
import SubNav from './SubNav'
export default {
  name: 'help-nav',
  components: { SubNav }
}
</script>

<style lang="scss" scoped>
</style>
